import { AccountIcon } from "../../Icons";

const EmptySelectionPlaceholder = () => {
  return (
    <div className="bg-gradient-primarycard rounded-3xl p-6 h-[300px] flex flex-col items-center justify-center text-center space-y-4">
      <div className="bg-background-hover rounded-full p-6">
        <AccountIcon className="w-12 h-12 text-text-secondary" />
      </div>
      <div>
        <h3 className="text-lg font-bold text-text-primary">
          Sub Account Details
        </h3>
        <p className="text-sm text-text-secondary mt-2">
          Select a sub account from the list to view details or actions.
        </p>
      </div>
    </div>
  );
};

export default EmptySelectionPlaceholder;
